module.exports = __webpack_public_path__ + "img/icon-sync.3fa86c5d.svg";